import React, { useState } from "react";

interface Team {
  id: number;
  team_id: string;
  team_name: string;
  [key: string]: any;
}

interface InviteTeamMateStatusProps {
  team: Team;
  onUpdate: () => void;
}

const InviteTeamMateStatus: React.FC<InviteTeamMateStatusProps> = ({
  team,
  onUpdate,
}) => {
  const [copied, setCopied] = useState(false);

  const handleCopyTeamInfo = async () => {
    const teamInfo = `${team.team_id}`;

    try {
      await navigator.clipboard.writeText(teamInfo);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error("Failed to copy text: ", err);
    }
  };

  return (
    <div className="bg-white rounded-lg p-6 shadow-sm">
      <div className="flex items-center space-x-2 mb-4">
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M13.3333 17.5V15.8333C13.3333 14.9493 12.9821 14.1014 12.3569 13.4763C11.7318 12.8512 10.884 12.5 9.99992 12.5H4.16658C3.28253 12.5 2.43468 12.8512 1.80956 13.4763C1.18444 14.1014 0.833252 14.9493 0.833252 15.8333V17.5M14.1666 9.16667L15.8333 10.8333L19.1666 7.5M10.4166 5.83333C10.4166 7.67428 8.9242 9.16667 7.08325 9.16667C5.2423 9.16667 3.74992 7.67428 3.74992 5.83333C3.74992 3.99238 5.2423 2.5 7.08325 2.5C8.9242 2.5 10.4166 3.99238 10.4166 5.83333Z"
            stroke="url(#paint0_linear_464_3997)"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <defs>
            <linearGradient
              id="paint0_linear_464_3997"
              x1="9.99992"
              y1="2.5"
              x2="9.99992"
              y2="17.5"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#403634" />
              <stop offset="1" stopColor="#1E1E1E" />
            </linearGradient>
          </defs>
        </svg>
        <h3 className="text-lg font-semibold text-gray-900">
          Invite a friend to your team
        </h3>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Team Name
          </label>
          <input
            type="text"
            value={team.team_name}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg bg-gray-50"
            readOnly
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Team ID
          </label>
          <input
            type="text"
            value={team.team_id}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg bg-gray-50"
            readOnly
          />
        </div>
      </div>

      <p className="text-sm text-gray-600 mb-4">
        You can copy your Team Info and send to your friend who should also have
        registered for a valid account.
      </p>

      <button
        onClick={handleCopyTeamInfo}
        className={`w-full py-3 px-4 rounded-lg font-medium transition-colors ${
          copied
            ? "bg-green-600 text-white"
            : "bg-gray-800 text-white hover:bg-gray-700"
        }`}
      >
        {copied ? "Copied!" : "Copy Team Info"}
      </button>
    </div>
  );
};

export default InviteTeamMateStatus;
